import { useState, useRef, useEffect } from 'react';
import { mangas } from '@/mocks/mangas';
import MangaCard from '@/components/base/MangaCard';

export default function HotRecommend() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollRef = useRef<HTMLDivElement>(null);
  const hotMangas = mangas.sort((a, b) => b.views - a.views).slice(0, 12);

  const scroll = (direction: 'left' | 'right') => {
    if (!scrollRef.current) return;
    const scrollAmount = 300;
    const newScrollLeft = scrollRef.current.scrollLeft + (direction === 'left' ? -scrollAmount : scrollAmount);
    scrollRef.current.scrollTo({ left: newScrollLeft, behavior: 'smooth' });
  };

  useEffect(() => {
    const ref = scrollRef.current;
    if (!ref) return;
    const handleScroll = () => {
      const maxScroll = ref.scrollWidth - ref.clientWidth;
      if (maxScroll > 0) {
        setCurrentIndex(Math.round(ref.scrollLeft / maxScroll * (hotMangas.length - 4)));
      }
    };
    ref.addEventListener('scroll', handleScroll, { passive: true });
    return () => ref.removeEventListener('scroll', handleScroll);
  }, [hotMangas.length]);

  return (
    <section className="py-14 md:py-20 bg-background-50" aria-labelledby="hot-recommend-title">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 id="hot-recommend-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm md:text-base mt-2">千万读者的共同选择，最受欢迎的漫画都在这里</p>
          </div>
          <div className="hidden md:flex items-center gap-2">
            <button
              onClick={() => scroll('left')}
              className="w-9 h-9 flex items-center justify-center rounded-full border border-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition-all duration-200"
              aria-label="向左滚动"
            >
              <i className="ri-arrow-left-s-line"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-9 h-9 flex items-center justify-center rounded-full border border-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition-all duration-200"
              aria-label="向右滚动"
            >
              <i className="ri-arrow-right-s-line"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-4 md:gap-5 overflow-x-auto scrollbar-hide pb-4 -mx-4 px-4 md:mx-0 md:px-0 snap-x snap-mandatory"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {hotMangas.map((manga) => (
            <div key={manga.id} className="flex-shrink-0 w-[160px] md:w-[180px] snap-start">
              <MangaCard
                id={manga.id}
                title={manga.title}
                author={manga.author}
                cover={manga.cover}
                category={manga.category}
                rating={manga.rating}
                tags={manga.tags}
                status={manga.status}
                views={manga.views}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}